import React, { useEffect, useState } from 'react';
import firebase from 'firebase';
import Order from './Order';
import { useStateValue } from "./StateProvider";
import "./Xyz.css"
import { db } from './firebase';
import CheckoutProduct from './CheckoutProduct';
import Hotel from './Hotel';
import { Link } from 'react-router-dom';

function Xyz({ order }) {

    const [{ basket, user }, dispatch] = useStateValue();
    const [orders, setOrders] = useState([]);


    useEffect(() => {
        // db
        //     .collection('users')
        //     .doc(user?.email)
        //     .collection('orders')
        //     .orderBy('created', 'desc')
        //     .onSnapshot(snapshot => (
        //         setOrders(snapshot.docs.map(doc => ({
        //             id: doc.id,
        //             data: doc.data()
        //         })))
        //     ))
        // db.collectionGroup("orders").get().then((snapshot) => {
        //     console.log(snapshot.docs.map(item => ({id: item.id, ...item.data()})))
        // })
        db.collectionGroup('orders').orderBy('created', 'desc').onSnapshot(snapshot => {
            setOrders(snapshot.docs.map(doc => ({
            id: doc.id,
            data: doc.data()
        })))
        })
        
    })
    
    return (
        <div className="orders__order">
           {orders?.map(order => (
               <Order order={order} />
           ))}
        </div>
    )
}

export default Xyz
